angular.module('impactx.deliveryadvice').controller('DeliveryAdviceBuyerListCtrl', [
    'selectedListItems',
    DeliveryAdviceBuyerListCtrl
]);

function DeliveryAdviceBuyerListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'ViewDeliveryAdviceBuyer'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/deliveryadvice/templates/deliveryadvicebuyerlist.row.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/deliveryadvice/listbuyer',
        id: "deliveryadvicebuyerlist",
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "deliveryadvicebuyer/" + selectedListItems.getFirstSelectedItem().pohId + "/" + selectedListItems.getFirstSelectedId();
    }
}